/**
 * Route for `report-access-by-level-own-team-all-team-per-role`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReportAccessByLevelOwnTeamAllTeamPerRolePage } from "../features/report-access-by-level-own-team-all-team-per-role/ReportAccessByLevelOwnTeamAllTeamPerRolePage";

export const reportAccessByLevelOwnTeamAllTeamPerRoleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/report-access-by-level-own-team-all-team-per-role",
	component: ReportAccessByLevelOwnTeamAllTeamPerRolePage,
});

export default reportAccessByLevelOwnTeamAllTeamPerRoleRoute;
